import { Component, Input } from '@angular/core';
import { DataTableColumnLink } from './data-table-column-link.config';

@Component({
  selector: 'data-table-column-link',
  imports: [],
  templateUrl: './data-table-column-link.component.html',
  styleUrl: './data-table-column-link.component.scss'
})
export class DataTableColumnLinkComponent {
  @Input() column!: DataTableColumnLink;
  @Input() item!: any;
}
